import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearchStarinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		clipPath: "url(#a)",
		children: [/* @__PURE__ */ _jsx("path", { d: "m21.004 21.004-5.35-5.35m-2.306-12.05a7.414 7.414 0 1 0 4.478 6.807" }), /* @__PURE__ */ _jsx("path", {
			d: "M16.001 9.003A3 3 0 0 1 19.002 6a3 3 0 0 1-3-3.001A3 3 0 0 1 13 6.001a3 3 0 0 1 3.001 3.001",
			clipRule: "evenodd"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M0 0h24v24H0z"
		})
	}) })]
});
export default SvgSearchStarinline;
